"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFirstDayOfTheMonth = exports.isLastDayOfTheMonth = exports.isFirstDayOfTheWeek = exports.isLastDayOfTheWeek = exports.getDayAbbreviations = exports.dateToToLongMonthString = exports.isValidEndDate = exports.getDateFromDateOrNow = exports.SelectedState = exports.HoverState = void 0;
var helperFunctions_1 = require("../utils/helperFunctions");
exports.HoverState = {
    HOVERED: 'HOVERED',
    HOVERED_WITHIN_HOVER_RANGE: 'HOVERED_WITHIN_HOVER_RANGE',
    HOVERED_END_OF_HOVER_RANGE: 'HOVERED_END_OF_HOVER_RANGE',
};
exports.SelectedState = {
    SELECTED: 'SELECTED',
    SELECTED_BEGINNING_OF_SELECTION: 'SELECTED_BEGINNING_OF_SELECTION',
    SELECTED_WITHIN_SELECTION_RANGE: 'SELECTED_WITHIN_SELECTION_RANGE',
    SELECTED_END_OF_SELECTION: 'SELECTED_END_OF_SELECTION',
};
var getDateFromDateOrNow = function (dateOrNow) {
    if (dateOrNow === 'NOW') {
        return new Date(Date.now());
    }
    return dateOrNow;
};
exports.getDateFromDateOrNow = getDateFromDateOrNow;
var isValidEndDate = function (dateOrNow, endDate) {
    if (dateOrNow === 'NOW') {
        return (0, helperFunctions_1.getDateAtEndOfDay)(new Date()) < endDate;
    }
    return dateOrNow < endDate;
};
exports.isValidEndDate = isValidEndDate;
var dateToToLongMonthString = function (date, locale) {
    return new Intl.DateTimeFormat(locale, {
        month: 'long',
    }).format(date);
};
exports.dateToToLongMonthString = dateToToLongMonthString;
var getDayAbbreviations = function (locale) {
    var getDayOfWeek = function (day) {
        var date = new Date(0);
        date.setDate(date.getDate() - date.getDay() + day);
        return date;
    };
    var dayAbbreviations = [];
    for (var i = 0; i < 7; i++) {
        dayAbbreviations.push(new Intl.DateTimeFormat(locale, {
            weekday: 'narrow',
        }).format(getDayOfWeek(i)));
    }
    return dayAbbreviations;
};
exports.getDayAbbreviations = getDayAbbreviations;
var isLastDayOfTheWeek = function (date) { return date.getDay() === 6; };
exports.isLastDayOfTheWeek = isLastDayOfTheWeek;
var isFirstDayOfTheWeek = function (date) { return date.getDay() === 0; };
exports.isFirstDayOfTheWeek = isFirstDayOfTheWeek;
var isLastDayOfTheMonth = function (date) {
    return date.getTime() === new Date(date.getFullYear(), date.getMonth() + 1, 0).getTime();
};
exports.isLastDayOfTheMonth = isLastDayOfTheMonth;
var isFirstDayOfTheMonth = function (date) { return date.getDate() === 1; };
exports.isFirstDayOfTheMonth = isFirstDayOfTheMonth;
